import { useState, useEffect } from "react";
import MainLayouts from "../../Layout/MainLayouts";
import { ReactComponent as ArrowLeftSquare } from "bootstrap-icons/icons/arrow-left-square-fill.svg";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";

const CommissionDetails = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [commission, setCommission] = useState(null);

    useEffect(() => {
        if (location.state && location.state.commission) {
            setCommission(location.state.commission);
        } else {
            // if no state passed, redirect back
            navigate("/admin/commission/list");
        }
    }, [location.state, navigate]);

    if (!commission) {
        return (
            <MainLayouts>
                <div className="flex justify-center items-center h-64">
                    <p className="text-gray-500">Loading commission details...</p>
                </div>
            </MainLayouts>
        );
    }

    return (
        <div>
            <MainLayouts>
                <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
                    {/* Breadcrumb */}
                    <section
                        className="w-full pl-[3%] pr-[3%] pt-3 my-3"
                        style={{ backgroundColor: "#F7F7F7" }}
                    >
                        <nav className="bg-gray-200 py-0 px-4 rounded-lg ">
                            <ol className="list-none p-0 inline-flex mb-2">
                                <li className="flex items-center">
                                    <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                                        Physical Product
                                    </p>
                                    <ChevronRightIcon />
                                </li>
                                <li className="flex items-center">
                                    <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                                        Commission
                                    </p>
                                    <ChevronRightIcon />
                                </li>
                                <li className="flex items-center">
                                    <p className="text-orange1 ">Details</p>
                                </li>
                            </ol>
                        </nav>
                    </section>

                    {/* Card */}
                    <section className="text-gray-600 body-font">
                        <div className="container px-1 py-1 mx-auto">
                            <div className="flex flex-wrap -m-2">
                                <div className="p-2 w-full">
                                    <div className="h-full flex border border-grey3 items-center p-4 rounded-lg">
                                        <div className="flex-grow">
                                            <h2 className="text-dash title-font font-medium">
                                                {commission.name || "Not Available"}
                                            </h2>
                                            <p className="text-gray-500 mt-1">
                                                {commission.description || "No description"}
                                            </p>
                                            <p className="text-gray-500 mt-1">
                                                <span className="font-medium">Status: </span>
                                                {commission.is_active ? "Active" : "Inactive"}
                                            </p>
                                            <p className="text-gray-500 mt-1">
                                                <span className="font-medium">Discount %: </span>
                                                {commission.discount_percentage}
                                            </p>
                                            <span className="ml-auto text-dash">
                                                {commission.created_at
                                                    ? new Date(commission.created_at).toLocaleString()
                                                    : "NOT AVAILABLE"}
                                            </span>
                                        </div>

                                        <Link
                                            to="/admin/commission/list"
                                            className="w-full sm:w-auto text-dGrey3 bg-darkGreen3 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                                        >
                                            <span className="flex justify-center sm:justify-start mx-2">
                                                <ArrowLeftSquare className="mr-2" />
                                                Back
                                            </span>
                                        </Link>
                                    </div>
                                </div>

                                {/* Pricing Rules */}
                                <div className="px-2 w-full">
                                    <div className="h-full flex flex-col border border-dash p-4 rounded-lg">
                                        <h3 className="text-lg font-medium mb-3 text-darkGreen3">
                                            Pricing Rules
                                        </h3>
                                        {commission.pricing_rules &&
                                            Object.entries(commission.pricing_rules).map(
                                                ([network, rule]) => (
                                                    <div
                                                        key={network}
                                                        className="flex border-t border-grey3 py-2 justify-between"
                                                    >
                                                        <span className="text-gray-500">{network} pcs</span>
                                                        <span className="ml-auto text-dash">
                                                            {rule.value} %
                                                        </span>
                                                    </div>
                                                )
                                            )}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </section>
                </div>
            </MainLayouts>
        </div>
    );
};

export default CommissionDetails;
